// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.editorClass {
  height: 100%;
  width: 100%;
  padding: 10px;
  padding-left: 0px;
}

.innerEditorItem::part(native) {
  padding-left: 0px;
}

.lableHTMLEditor {
  padding-bottom: 10px;
}`, "",{"version":3,"sources":["webpack://./src/components/general components/reporthtml-form/reporthtml-form.component.scss","webpack://./src/components/general%20components/reporthtml-form/reporthtml-form.component.scss"],"names":[],"mappings":"AAAA;EACI,YAAA;EACA,WAAA;EACA,aAAA;EACA,iBAAA;ACCJ;;ADGI;EACI,iBAAA;ACAR;;ADIA;EAEI,oBAAA;ACFJ","sourcesContent":[".editorClass {\n    height: 100%;\n    width: 100%;\n    padding: 10px;\n    padding-left: 0px;\n}\n\n.innerEditorItem{\n    &::part(native) {\n        padding-left: 0px;\n    }\n}\n\n.lableHTMLEditor{\n    //color: red;\n    padding-bottom: 10px;\n}\n\n",".editorClass {\n  height: 100%;\n  width: 100%;\n  padding: 10px;\n  padding-left: 0px;\n}\n\n.innerEditorItem::part(native) {\n  padding-left: 0px;\n}\n\n.lableHTMLEditor {\n  padding-bottom: 10px;\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
